export default "__VITE_ASSET__Dwc7Ndvn__"